export const escapeUrlRegExp = (str: string): string => {
	return str.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
};
